import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.OceanCleanup;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "OceanCleanup.Phaser.IntroductionScene.1",
            "OceanCleanup.Phaser.IntroductionScene.2",
            "OceanCleanup.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/OceanCleanupGame/scenes/GameIntro.ts